import DateRange from '../store/schema/DateRange';
import { DateRange as owaDateRange } from 'mini-datetime-utils';
import { getTimestamp, OwaDate, userDate } from 'owa-datetime';

/**
 * Converts the epoch time in milliseconds to DisplayDate.
 * @param timeInMilliSeconds The number of milliseconds since midnight, 1970-01-01.
 */
export function convertEpochTimeToDisplayDate(timeInMilliSeconds: number): OwaDate {
    return userDate(timeInMilliSeconds);
}

/**
 * Converts dateRange in milliseconds to dateRange in DisplayDates.
 * @param dateRange DateRange with start and end times in milliseconds (epoch time)
 */
export function convertDateRangeToDisplayDateRange(dateRange: DateRange): owaDateRange {
    const a = {
        start: convertEpochTimeToDisplayDate(dateRange.start),
        end: convertEpochTimeToDisplayDate(dateRange.end),
    };
    return a;
}

/**
 * Converts dateRange in DisplayDates to dateRange in milliseconds
 * @param dateRange DateRange in display dates
 */
export function convertDisplayDateRangeToDateRange(dateRange: owaDateRange): DateRange {
    return {
        start: getTimestamp(dateRange.start),
        end: getTimestamp(dateRange.end),
    };
}
